package ui.server

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*
import tools.*
import ui.server.detail.*

@VM
class ServerListingVM : NavigationViewModel() {

    private lateinit var scopeUi: ServerListingScope

    var canAdd by mutableStateOf(false)
        private set

    var state by mutableDataState<ServerListingScope.Wrapper>()
        private set


    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        class New(val item: Io.ListingServer.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: ServerListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is New -> vm.newServer(act.item)
                        }
                    }
                }
            }
        }
    }


    private fun newServer(item: Io.ListingServer.Item) {
        scope.launch {
            runCatching {
                val new = Repository.api.server.add(item)
                state.entry?.add(0, new)
                scopeUi.nav.findRoot().navTo_ServerUI(ServerArgs(serverId = new.id))
            }.onFailure {
                it.printStackTrace()
            }
        }
    }

    fun init(scopeUi: ServerListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        canAdd = scopeUi.login.canServerAdd()


        scope.launch {
            runCatching {
                state = DataState.Result(
                    ServerListingScope.Wrapper(
                        Repository.api.server.listing()
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(getString(Res.string.err_connection_interrupted))
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
